// extracted by css-extract-rspack-plugin
export default {"row":"l3Y0a","nowrap":"CJx3L"};